/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only adjusts the loader's position/phase, converting to .tsx is a separate migration */
import { Box, Flex } from '@chakra-ui/react';
import { Loader } from '@/design-system/loader';

export const AppLoading = () => {
  return (
    <Box flex="1" height="100%">
      {/* Pinned to the viewport centre, not the container's: the boot loader
          renders before the shell exists and the route loader inside it, and
          centring each in its own box moved the spinner by the nav's width
          and height between the two — it read as a second spinner. */}
      <Flex
        position="fixed"
        inset={0}
        alignItems="center"
        justifyContent="center"
        pointerEvents="none"
      >
        <Loader />
      </Flex>
    </Box>
  );
};
